// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__QU74e","col":"styles_col__1UjjV"};